

export type Placement =
  | 'top'
  | 'bottom'
  | 'left'
  | 'right'
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right'

export enum ZIndex {
  TOASTER = 1700,
  OVERLAY = 1600,
  DROPDOWN = 1500,
  TOOLTIP = 1400,
  POPOVER = 1300,
  MODAL = 1200,
  DRAWER = 1100,
  NAVBAR = 1000
}

export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  SPACE: ' ',
  ESCAPE: 'Escape',
  TAB: 'Tab',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_LEFT: 'ArrowLeft',
  HOME: 'Home',
  END: 'End'
} as const
